import { useQuery } from '@tanstack/react-query';
import { admin } from '@repletoryreach/sdk-api';
import { Card, Stack, Title, Text, Group, Badge, Skeleton } from '@repletoryreach/sdk-ui';
import { useT } from '../../../../i18n/I18nProvider';
import { formatDateTime } from '../../../../lib/format';

/**
 * Where this organisation stands on the agreements it must accept, and every
 * acceptance with who, when and from where (2 October 2026). The record a
 * regulator or the customer would ask for.
 */
export function AgreementsCard({ orgId }: { orgId: string }) {
  const t = useT();
  const q = useQuery({ queryKey: ['admin', 'agreements', 'org', orgId], queryFn: () => admin.getOrganisationAgreements(orgId) });
  const d = q.data?.data;
  return (
    <Card withBorder>
      <Stack gap="sm">
        <Title order={4}>{t('tenants.view.agreements.title')}</Title>
        {q.isPending ? <Skeleton height={40} /> : (
          <>
            {(d?.status ?? []).map((s) => (
              <Group key={s.kind} justify="space-between">
                <Text fz="sm">{s.name}</Text>
                <Badge variant="light" color={s.accepted ? 'green' : 'red'}>
                  {s.accepted ? t('tenants.view.agreements.accepted', { version: s.current_version }) : t('tenants.view.agreements.notAccepted', { version: s.current_version })}
                </Badge>
              </Group>
            ))}
            {(d?.history ?? []).length === 0 ? (
              <Text fz="sm" c="var(--rr-color-text-muted)">{t('tenants.view.agreements.none')}</Text>
            ) : (d?.history ?? []).map((h) => (
              <Text key={`${h.kind}-${h.version}`} fz="sm" c="var(--rr-color-text-muted)">
                {t('tenants.view.agreements.line', {
                  version: h.version, when: formatDateTime(h.accepted_at),
                  who: h.accepted_by_name ? `${h.accepted_by_name} (${h.accepted_by_email ?? ''})` : (h.accepted_by_email ?? '?'),
                  ip: h.accepted_ip ?? '?'
                })}
              </Text>
            ))}
          </>
        )}
      </Stack>
    </Card>
  );
}
